import React from 'react';
import InspectionPhotoField from './InspectionPhotoField';
import {
  RATING_ARIA_LABEL,
  RATING_COLUMN_STYLES,
  RATING_KEYS,
  RATING_SHORT_LABEL,
} from './checklistRatingConstants';

function ChecklistRatingQuestionRow({
  question,
  answer,
  rating,
  note,
  readOnly,
  onRatingChange,
  onNoteChange,
  onUploadPhoto,
  onDeletePhoto,
  onCreateServiceRequest,
}) {
  return (
    <div className="inspection-question-row inspection-question-row--rating">
      <div className="inspection-q-question">{question.questionText}</div>

      {RATING_KEYS.map((c) => (
        <div
          key={c}
          className={`inspection-q-rating inspection-q-rating--${c}`}
          style={{
            backgroundColor: RATING_COLUMN_STYLES[c].cell,
            boxShadow:
              rating === c ? 'inset 0 0 0 3px rgba(33, 37, 41, 0.45)' : undefined,
          }}
        >
          <label className={readOnly ? 'read-only' : undefined}>
            <input
              type="radio"
              className="form-check-input m-0"
              name={`rating-${question.id}`}
              checked={rating === c}
              onChange={() => onRatingChange(question.id, c)}
              disabled={readOnly}
              aria-label={RATING_ARIA_LABEL[c]}
            />
            <span className="inspection-q-rating-label d-md-none ms-1">
              {RATING_SHORT_LABEL[c]}
            </span>
          </label>
        </div>
      ))}

      <div className="inspection-q-note">
        <label className="inspection-q-field-label d-md-none">Note</label>
        <textarea
          className="form-control form-control-sm"
          rows={2}
          value={note ?? ''}
          onChange={(e) => onNoteChange(question.id, e.target.value)}
          disabled={readOnly}
        />
      </div>

      <div className="inspection-q-actions">
        <InspectionPhotoField
          answer={answer}
          readOnly={readOnly}
          onUpload={onUploadPhoto}
          onDelete={onDeletePhoto}
        />
        <div className="inspection-q-sr">
          {!readOnly && (
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={() => onCreateServiceRequest(question)}
            >
              Create SR
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChecklistRatingQuestionRow;
